import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-how-it-works-item',
  templateUrl: './how-it-works-item.component.html',
  styleUrls: ['./how-it-works-item.component.scss']
})
export class HowItWorksItemComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() image: string = '';
  @Input() number: string = '';
  @Input() direction: string = 'left';
}
